import { RootState } from '@/plugins/store';
import { GetterTree } from 'vuex';
import { SuiviDevisState } from './state';

export const getters: GetterTree<SuiviDevisState, RootState> = {
    getDevisItems(state) {
        return state.devis;
    },
    getDevisFilterSite(state): number[] {
        return state.filterSite;
    },
    getDevisFilterStatus(state): string[] {
        return state.filterStatus;
    },
    getDevisFilterDevisId(state): string {
        return state.filterDevisId;
    },
    getDevisFilterNumero(state) {
        return state.filterNumero;
    },
    getDevisFilterNumFactures(state) {
        return state.filterNumFactures;
    },
    getDevisFilterDateDebut(state): string {
        return state.filterDateDebut;
    },
    getDevisFilterDateFin(state): string {
        return state.filterDateFin;
    },
    getDevisIsLoading(state) {
        return state.isLoading;
    },
    getDevisPage(state) {
        return state.page;
    },
    getDevisNbOfPages(state) {
        return state.nbOfPages;
    },
    getDevisScroll(state) {
        return state.scroll;
    },
    getDevisSort(state) {
        return state.sort;
    },
    getDevisCount(state) {
        return state.count;
    },
    getDevisTableHeader(state) {
        return state.tableHeader;
    },
    getBonCommande(state) {
        return state.bonDeCommandeFile;
    },
    getIsExportXlsLoading(state) {
        return state.isExportXlsLoading;
    },

    //Interventions

    getInterventionsItems(state) {
        return state.interventions;
    },
    getInterventionFilterStatus(state): Array<string> {
        return state.filterStatusInterventions;
    },
    getInterventionFilterInterventionId(state): string {
        return state.filterInterventionId;
    },
    getInterventionFilterPredictedDateFrom(state): string {
        return state.filterPredictedDateFrom;
    },
    getInterventionFilterPredictedDateTo(state): string {
        return state.filterPredictedDateTo;
    },
    getInterventionsIsLoading(state) {
        return state.isLoadingInterventions;
    },
    getInterventionsPage(state) {
        return state.pageInterventions;
    },
    getInterventionsNbOfPages(state) {
        return state.nbOfPagesInterventions;
    },
    getInterventionsScroll(state) {
        return state.scrollInterventions;
    },
    getInterventionsSort(state) {
        return state.sortInterventions;
    },
    getInterventionsCount(state) {
        return state.countInterventions;
    },
    getInterventionsTableHeader(state) {
        return state.tableHeaderInterventions;
    },
};
